module.exports = __webpack_public_path__ + "img/24.55a07710.jpg";